import { Locales } from '@griply/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/components/ui/custom-form-select';

export const useSupportedLanguageOptions = () => {
  const { t } = useTranslation();

  return useMemo<Option[]>(
    () => [
      {
        value: Locales.EnUS,
        label: t('general.labels.languages.en-us'),
      },
      {
        value: Locales.NlNL,
        label: t('general.labels.languages.nl-nl'),
      },
      {
        value: Locales.EsES,
        label: t('general.labels.languages.es-es'),
      },
      {
        value: Locales.DeDE,
        label: t('general.labels.languages.de-de'),
      },
    ],
    [t],
  );
};
